import { createApi } from "@reduxjs/toolkit/query/react";

import { Docket } from "@/interfaces/workdocket.interface";
import { BaseWithAuth, getCustomerId } from "@/utils/helpers";

export const C_DocketApi = createApi({
  reducerPath: "C_DocketApi",
  baseQuery: BaseWithAuth(),
  tagTypes: ["docket"],
  endpoints: (builder) => ({
    // get all the Customers Docket
    getCustomersDockets: builder.query<
      GeneralResponse<Docket[]>,
      { filters?: string }
    >({
      query: ({ filters }) =>
        `customer/${getCustomerId()}/workDockets/${filters ? `?${filters}` : ""}`,
      providesTags: ["docket"],
    }),
  }),
});

export const { useGetCustomersDocketsQuery } = C_DocketApi;
